import React, {useMemo, useState} from "react";
import {Avatar} from "@material-ui/core";
import {EnhancedTableToolbar} from "./TableToolbar";
import AntDataGrid from "../../shared/components/AntDataGrid";
import {useDispatch, useSelector} from "react-redux";
import {fetchInternalIdManyFound, selectSyncErrors} from "../../redux/slices/syncErrors";
import {ItemDetails} from "./ItemDetails";

const columns = [
    {
        title: 'Image', dataIndex: 'ImageUrl', key: 'id',
        render: (image) => {
            return (
                <React.Fragment>
                    {
                        image
                            ? <Avatar alt={'...'} src={image}/>
                            : <Avatar>no</Avatar>
                    }
                </React.Fragment>
            )
        }
    },
    {title: 'Prosoft Id', dataIndex: 'InternalId', key: 'InternalId'},
    {
        title: 'Code barre', dataIndex: 'Barcode', key: 'Barecode',
        render: (codes) => {
            return (
                <React.Fragment>
                    {
                        codes && codes.toString()
                    }
                </React.Fragment>
            )
        }
    },
    {title: 'Nom Produit', dataIndex: 'Name', key: 'Name'},
];

let isInitialized = false;

export default function SyncErrors() {
    const [isModalShown, setIsModalShown] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState(null);

    const {list} = useSelector(selectSyncErrors);

    const dispatch = useDispatch();

    const formated = useMemo(() => {

        if (list) return (list.map(item => ({key: item.id, ...item})))
            .sort((a, b) => a.InternalId > b.InternalId)
        else
            return []

    }, [list])


    if (!isInitialized) {
        setIsLoading(true)
        isInitialized = true;
        dispatch(fetchInternalIdManyFound({onResolve: () => setIsLoading(false)}));
    }


    const handleSelection = (item) => {
        setItem(item)
        setIsModalShown(true);
    }

    return (
        <>
            <AntDataGrid
                isLoading={isLoading}
                columns={columns}
                data={formated}
                ToolBar={EnhancedTableToolbar}
                doubleClickAction={row => handleSelection(row)}
            />

            {
                item && (
                    <ItemDetails
                        open={isModalShown}
                        setOpen={setIsModalShown}
                        item={item}
                    />
                )
            }

        </>
    )
}
